import React from 'react';

const TutorialsContext = React.createContext(null);

export default TutorialsContext;
